// extracted by mini-css-extract-plugin
export default {"review":"ReviewProducts_review__PK5Yi","card":"ReviewProducts_card__4mrOa"};